import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const SectionContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '420px',
  background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)', // dark slate gradient
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '80px 24px',
  border: '1px solid #334155',
  borderLeft: 'none',
  borderRight: 'none',
  [theme.breakpoints.up('md')]: {
    padding: '96px 48px'
  },
  [theme.breakpoints.up('lg')]: {
    padding: '96px 64px'
  },
  [theme.breakpoints.down('md')]: {
    minHeight: '350px'
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '300px'
  }
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '60px',
  maxWidth: '1200px',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: '30px',
    textAlign: 'center'
  }
}));

const IllustrationImage = styled('img')(({ theme }) => ({
  width: '264px',
  height: '244px',
  flexShrink: 0,
  [theme.breakpoints.down('md')]: {
    width: '200px',
    height: '185px'
  },
  [theme.breakpoints.down('sm')]: {
    width: '160px',
    height: '148px'
  }
}));

const TextContent = styled(Typography)(({ theme }) => ({
  flex: 1,
  fontFamily: 'Inter, sans-serif',
  fontSize: '26px',
  color: '#ffffff',
  letterSpacing: '0',
  lineHeight: '40px',
  [theme.breakpoints.down('md')]: {
    fontSize: '22px',
    lineHeight: '34px'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
    lineHeight: '28px'
  }
}));

const AllInOneSolutionSection = () => {
  return (
    <SectionContainer>
      <ContentWrapper>
        <IllustrationImage
          src="https://c.animaapp.com/mgbvruh0ta8bZ7/img/seo-bro.png"
          alt="SEO Illustration"
        />
        <TextContent>
          <Box component="span" sx={{ fontWeight: 600, display: 'block', marginBottom: '16px' }}>
            All-in-One Local SEO Solution for Every Business, On Every Device.
          </Box>
          <Box component="span" sx={{ 
            fontWeight: 500, 
            fontStyle: 'italic', 
            fontSize: { xs: '16px', sm: '18px', md: '22px' }, 
            display: 'block' 
          }}>
            "Designed to work for any local business, we have you covered. With mobile-first visibility and one easy dashboard to manage reviews, rankings, and listings, your business stays in control wherever your customers search."
          </Box>
        </TextContent>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default AllInOneSolutionSection;
